export default (context) => {
    const appKey = context.env.appDynamicsKey || process.env.NUXT_ENV_APP_DYNAMICS_KEY;
    if (!appKey) {
        // No key available, so skip App Dynamics setup
        return;
    }
    Object.assign(window, {
        'adrum-start-time': new Date().getTime(),
        'adrum-config': {
            appKey,
            adrumExtUrlHttp: 'http://cdn.appdynamics.com',
            adrumExtUrlHttps: 'https://cdn.appdynamics.com',
            beaconUrlHttp: 'http://pdx-col.eum-appdynamics.com',
            beaconUrlHttps: 'https://pdx-col.eum-appdynamics.com',
            useHTTPSAlways: true,
            xd: { enable: false },
            spa: { spa2: true },
        },
    });
    const script = document.createElement('script');
    script.src = '//cdn.appdynamics.com/adrum/adrum-latest.js';
    document.body.appendChild(script);
};
//# sourceMappingURL=appDynamics.js.map